"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StringUtils_1 = require("./StringUtils");
var Utils_1 = require("./Utils");
var DataUtils = /** @class */ (function () {
    function DataUtils() {
    }
    /**
     * Lee un  valor de un recordset y devuelve la conversión a entero
     *
     * @param DataSource Origen de datos del que se va a leer.
     * @param FieldName  Nombre del campo a leer.
     * @return Devuelve el valor del campo. Si no es numérico posiblemente devuelva cero.
     */
    DataUtils.RsReadLong = function (DataSource, FieldName) {
        var l = 0;
        try {
            l = DataSource.getInt(FieldName);
        }
        catch (e) {
            // Ignorar esta excepción... puede ser que el campo no exista o algo así...
        }
        return l;
    };
    /**
     * Lee un  valor de un recordset y devuelve la conversión a entero
     *
     * @param DataSource Origen de datos del que se va a leer.
     * @param FieldName  Nombre del campo a leer.
     * @return Devuelve el valor del campo. Si no es numérico posiblemente devuelva cero.
     */
    DataUtils.RsReadInt = function (DataSource, FieldName) {
        return this.RsReadLong(DataSource, FieldName);
    };
    /**
     * A10031101:	Programación del registro de operaciones en la cola para javoso.
     * Esta función se usa para desdoblar la ejecución de SQLs, así que había que programarla.
     * Leer una cadena de un resultset. Emplea mecanismos de seguridad para evitar que se
     * devuelva un nulo.
     *
     * @param DataSource
     * @param FieldName
     * @return
     */
    DataUtils.RsReadString = function (DataSource, FieldName) {
        var str = Utils_1.Utils.EMPTY_STRING;
        try {
            str = DataSource.getString(FieldName);
            str = StringUtils_1.default.SafeToString(str);
        }
        catch (e) {
            e.printStackTrace();
        }
        return str;
    };
    return DataUtils;
}());
exports.default = DataUtils;

//# sourceMappingURL=DataUtils.js.map
